import { scopedKey } from "@/queries/scope";
import { observedRead, type THintTargets } from "./types";

/**
 * The status lists' and project workflow rules' hint rows (NG-2798). Each is
 * cached under its own domain, its 403 door included, and read only through
 * Query, so the rows run with `query-cache` off too. An open settings list,
 * status picker or workflow editor observing one is re-read.
 */
const domainRead = (domain: string) =>
  observedRead((scope) => scopedKey(scope, domain), { flag: null });

export const STATUS_LISTS_HINTS: THintTargets = {
  "project-states:list": domainRead("project-states"),
  "work-item-states:list": domainRead("work-item-states"),
  "request-statuses:list": domainRead("request-statuses"),
  "request-reasons:list": domainRead("request-reasons"),
  "project-workflows:list": domainRead("project-workflows"),
};
